'use client';

import Image from 'next/image';
import { TyoeDoctorInfo } from '../types/AdmissionType';

export default function HeaderMission({ docInfo }: TyoeDoctorInfo) {
    const { doctor_image, mainSpecialty, name } = docInfo;

    return (
        <>
            <div className="w-full">
                <div className="flex gap-3 items-center">
                    <Image
                        alt={`${name}`}
                        width={1000}
                        height={1000}
                        src={
                            doctor_image
                                ? process.env.NEXT_PUBLIC_STATIC_URL +
                                  doctor_image
                                : ''
                        }
                        className="rounded-full !size-[54px]"
                    />
                    <div className="flex gap-2 flex-col">
                        <p className="font-bold text-base">{name}</p>
                        <p className="text-[#00000080] text-sm">
                            {mainSpecialty && mainSpecialty.name}
                        </p>
                    </div>
                </div>
                {/* <div
                    className={cn(
                        'p-4 col-span-12 mt-0 lg:col-span-4 flex-1 size-full',
                        !per_visit && 'lg:col-span-12',
                    )}
                >
                   <div className="text-right">
                        <p className="font-bold text-base">آدرس مطب</p>
                        <p className="!text-sm pt-2 text-[#222222D6] text-justify">
                            {clinic?.address ?? address}
                        </p>
                    </div>
                </div> */}
            </div>
            {/* {per_visit && (
                <Box className="col-span-12 mt-3 lg:col-span-5 bg-[#FFFCEC] px-4 pt-4 pb-8 border_box w-full">
                    <p className="flex text-[#D30206] text-base font-bold">
                        <span className="mb-auto mt-0.5">
                            <IoAlertCircleOutline className="ml-1 text-[#D30606] text-xl" />
                        </span>
                        پیش نیازهای مراجعه به پزشک:
                    </p>
                    <p className="text-sm pt-3 text-justify text-[#222222D6]">
                        {parse(per_visit)}
                    </p>
                </Box>
            )} */}
        </>
    );
}
